module.exports = __webpack_public_path__ + "static/media/disabledRightArrow.e7d07e29.svg";